/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import { Col, Card, CardBody, Badge } from "../../components/ui";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withRouter } from "../../hooks/withRouter";
import dayjs from "dayjs";
import "./index.scss";

const Post = ({ col, post, type, navigate, SuggestedPost }) => {
  return (
    <Col lg={col} md="12" className={"mainCard"}>
      <Card
        small
        className="card-post mb-4"
        style={{ overflow: "hidden", height: "95%" }}
      >
        {post.author.isFeaturedContributor && (
          <h4 class="ribbon">Featured Contributor</h4>
        )}
        <Link to={post.url}>
          <h5 style={{ marginBottom: 5 }} className="card-title">
            {post.title}
          </h5>
        </Link>
        <div style={{ marginBottom: 20 }} className="card-post__author d-flex">
          <small className="dateText">
            {dayjs(post.publishedAt).format("MMM Do, YYYY")} /
          </small>
          <small className="text-muted">
            <Badge
              pill
              className={`card-post__category bg-${post.userTypeTheme}`}
            >
              {post.userType}
            </Badge>
          </small>
          <div className="d-flex flex-column justify-content-center ml-1 author-data">
            <small className="dateText">
              <Link to={`/analyst/${post.author.slug}`} className={"black"}>
                By {post.author.name}
              </Link>
            </small>
          </div>
        </div>
        <CardBody>
          <Badge
            pill
            style={{ marginBottom: 20 }}
            className={`card-post__category badge-content-type`}
          >
            {post.contentTypeId === 1 ? "Blog" : "Video"}
          </Badge>
          {post.tags.map((tag, idx) => (
            <Badge pill className={`card-post__category badge-content-tag`}>
              {tag.name}
            </Badge>
          ))}
          {post.educationTopics.map((topic, idx) => (
            <Badge
              pill
              className={`card-post__category badge-content-education`}
            >
              {topic.name}
            </Badge>
          ))}
          <div
            className="card-post__image"
            style={{ backgroundImage: `url('${post.image.small}')` }}
          />
          {!SuggestedPost && (
            <p
              className="excerptText"
              dangerouslySetInnerHTML={{ __html: post && post.excerpt }}
            ></p>
          )}
          <Link to={post.url}>
            {" "}
            <label className="readMore">{"Read more >"}</label>
          </Link>
        </CardBody>
      </Card>
    </Col>
  );
};

Post.propTypes = {
  /**
   * Posts in col.
   */
  col: PropTypes.string,
  /**
   * Post data.
   */
  post: PropTypes.object,
  /**
   * Post type.
   */
  type: PropTypes.string,
};

export default withRouter(Post);
